import type { MessageHandlerDeps } from '../../message-handler-deps.js';
import { sendSessionGitResult } from './send-session-git-result.js';

type SessionGitReply = (payload: Record<string, unknown>, encryptedFields?: readonly string[]) => void;

export async function handleSessionGitCommitAction(
  deps: MessageHandlerDeps,
  sessionId: string,
  msg: {
    branch?: unknown;
    message?: unknown;
    pushAfterCommit?: unknown;
  },
  reply: SessionGitReply,
): Promise<void> {
  const branch = typeof msg.branch === 'string' ? msg.branch : '';
  const message = typeof msg.message === 'string' ? msg.message : '';
  const pushAfterCommit = msg.pushAfterCommit === true;
  if (!branch.trim() || !message.trim()) {
    reply({ ok: false, error: 'branch and message are required for commit' });
    return;
  }

  const commitRes = await deps.sessionWorktreeManager.commitSession({
    sessionId,
    branch: branch.trim(),
    message: message.trim(),
    push: pushAfterCommit,
  });
  if (!commitRes.ok) {
    reply({ ok: false, error: commitRes.error ?? 'Commit failed' });
    return;
  }

  const st = await deps.sessionWorktreeManager.getSessionWorkingTreeStatus(sessionId);
  reply({
    ok: true,
    hasUncommittedChanges: st.hasUncommittedChanges,
    hasUnpushedCommits: st.hasUnpushedCommits,
    uncommittedFileCount: st.uncommittedFileCount,
  });
}
